import { AssetDestination } from '~/components/send-all-assets-to/SendAllAssetsTo';

import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createSendAllAssetsEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackSendAllAssets = (
    source: PosthogTrackingSource,
    destination: AssetDestination
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SEND_ALL_ASSETS,
      properties: { source, destination },
    });

  return { trackSendAllAssets };
};
